<!--订单详情-->
<template>
  <div class="order-details">
    <!--用户信息-->
    <div class="user-box">
      <div class="user-info-box">
        <img :src="userInfo.userImg|| require('../../assets/img/common/tx-default.png')" class="avata" v-cloak />
        <h3>{{userInfo.nickName}}</h3>
        <div class="info-contact cf">
          <i class="icon icon-phone">
            <img src="../../assets/img/common/icon-phone.png" />
          </i>
          <span v-cloak>{{userInfo.mobileNumber}}</span>
        </div>
      </div>

      <!--上传简历盒子-->
      <div class="user-resume-box" v-if="false">
        <!-- !userInfo.resumeUrl -->
        <div class="upload-box">
          <input
            type="file"
            class="real-upload-btn"
            accept=".doc, .docx, .pdf, .xls, .xlsx, .png, .jpg, .jpeg"
            @change="uploadResuem"
          />
          <a href="javascript:;" class="fake-upload-btn">
            <i>+</i>上传原始简历
          </a>
          <p class="upload-tips">支持上传doc、docx、pdf、xls、xlsx、png、jpg、jpeg格式，大小不超过10M</p>
        </div>
      </div>

      <!--文件展示-->
      <div class="user-file-box" v-if="false">
        <h3 :title="userInfo.resumeName">
          <i class="icon">
            <img src="../../assets/img/common/icon-file.png" />
          </i>
          {{userInfo.resumeName}}
        </h3>
        <p class="time">
          {{userInfo.uploadTime.substr(0,userInfo.uploadTime.length-3)}}
          <span>{{userInfo.fileSizeStr}}</span>
        </p>
        <div class="file-btn-box">
          <a
            :href="userInfo.resumeUrl"
            :download="userInfo.resumeName"
            class="btn-file btn-download"
          >下载</a>
          <div class="upload-box-small">
            <input
              type="file"
              class="samll-upload-btn"
              accept=".doc, .pdf, .xls, .png, .jpg, .jpeg, .docx"
              @change="uploadResuem"
            />
            <a href="javascript:;" class="btn-file btn-reupload">重新上传</a>
          </div>
        </div>
      </div>
      <!--下载原始简历-->
      <div class="user-resume-box">
        <div class="upload-box">
          <input type="button" class="real-upload-btn" @click="downloadOriginalResuem" />
          <a href="javascript:;" class="fake-upload-btn">下载原始简历</a>
          <p class="upload-tips">支持下载docx、pdf格式</p>
        </div>
      </div>
    </div>

    <div class="tabs">
      <ul class="tabs-ul cf">
        <li
          class="tab-links"
          :class="{'active':item.active}"
          v-for="(item,index) in itemList"
          :key="item.serviceItemId"
          @click="switchTab(index,item.active,item.serviceItemId)"
        >
          {{item.serviceItemName}}
          <!--<span class="deliver-time" v-show="item.active&&item.deliverTime">最近一次交付时间：<span>{{item.deliverTime}}</span><span class="important">文件交付后再次修改数据用户端会同步更新</span></span>-->
        </li>
      </ul>

      <!--职业规划操作按钮组activeTypeId==1-->
      <div class="resume-op-box cf" v-if="activeTypeId==1">
        <span class="deliver-time" v-if="itemList[0].deliverTime">
          最近一次交付时间：
          <span>{{itemList[0].deliverTime}}</span>
          <span class="important">文件交付后再次修改数据用户端会同步更新</span>
        </span>
        <div class="op-box">
          <a
            href="javascript:;"
            class="op-btn deliver-btn"
            :title="!isEditable?'已完成或已退款的订单不能进行此操作':''"
            :class="{'disabled':!isEditable}"
            @click="checkDelivery"
          >交付</a>
          <a href="javascript:;" class="op-btn export-btn" @click="checkExport">导出</a>
        </div>
      </div>
    </div>

    <div class="tabs-container">
      <div v-show="activeTypeId==1">
        <!--基本信息-->
        <resume-base-info
          :orderId="orderId"
          :orderDetailId="resumeOrderDetailId"
          :resumeId="resumeId"
          @now-i-get-resume="changeResumeId"
          :editable="isEditable"
          @set-edit-status="changeEditAble"
        />

        <div v-if="didResumeIdGet" v-cloak>
          <!--求职意向--地点选择-->
          <resume-job-intension
            :orderId="orderId"
            :resumeId="resumeId"
            :editable="isEditable"
            @set-edit-status="changeEditAble"
          />
          <!--工作经历-->
          <resume-work-experience
            :orderid="orderId"
            :resumeId="resumeId"
            :editable="isEditable"
            @set-edit-status="changeEditAble"
          />
          <!--项目经历-->
          <resume-project-experience
            :resumeId="resumeId"
            :editable="isEditable"
            @set-edit-status="changeEditAble"
          />
          <!--教育背景-->
          <resume-educational-background
            :resumeId="resumeId"
            :editable="isEditable"
            @set-edit-status="changeEditAble"
          />
          <!--个人简介-->
          <resume-self-introduction
            :resumeId="resumeId"
            :editable="isEditable"
            @set-edit-status="changeEditAble"
          />
          <!--语言能力-->
          <resume-language-ability
            :resumeId="resumeId"
            :editable="isEditable"
            @set-edit-status="changeEditAble"
          />
        </div>
      </div>

      <!--面试辅导-->
      <div class="planWrap" v-if="activeTypeId==3">
        <interview-editor
          :orderId="orderId"
          :orderDetailId="interviewOrderDetailId"
          :interviewId="interviewId"
          :editable="isEditable"
          :dataSource="itemList"
          @askToDelivery="checkDelivery"
          @askToExport="checkExport"
        />
      </div>

      <!--职业生涯规划-->
      <div class="planWrap" v-if="activeTypeId==2">
        <plan-editor
          :orderId="orderId"
          :orderDetailId="planOrderDetailId"
          :planId="planId"
          :editable="isEditable"
          :dataSource="itemList"
          @askToDelivery="checkDelivery"
          @askToExport="checkExport"
        />
      </div>
    </div>

    <!--意外错误时显示-->
    <fatal-error :show="showFatalError" :errortext="fatalErrorText" />

    <!--交付提示-->
    <el-dialog
      title="提示"
      :visible="showDeliveryModal"
      width="400px"
      @close="showDeliveryModal=false"
      :lock-scroll="false"
    >
      <span v-if="activeTypeId==1">确定交付简历？</span>
      <span v-if="activeTypeId==2">确定交付职业生涯规划</span>
      <span v-if="activeTypeId==3">确定交付面试辅导</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDeliveryModal = false">取 消</el-button>
        <el-button type="primary" @click="deliveryResume(1)" v-if="activeTypeId==1">确 定</el-button>
        <el-button type="primary" @click="deliveryCareerPlan(2)" v-if="activeTypeId==2">确 定</el-button>
        <el-button type="primary" @click="deliveryInterview(3)" v-if="activeTypeId==3">确 定</el-button>
      </span>
    </el-dialog>

    <!--导出窗口-->
    <el-dialog
      title="请选择导出格式"
      :visible="showExportModal"
      width="400px"
      custom-class="export-modal"
      @close="showExportModal=false"
      :lock-scroll="false"
    >
      <div class="export-options">
        <label>格式</label>
        <template>
          <el-radio v-model="exportFileType" label="1">.doc</el-radio>
          <el-radio v-model="exportFileType" label="2">.pdf</el-radio>
        </template>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showExportModal = false">取 消</el-button>
        <el-button type="primary" @click="exportFile">确 定</el-button>
      </span>
    </el-dialog>

    <!--下载原始简历窗口-->
    <el-dialog
      title="请选择导出格式"
      :visible="showOriginalExportModal"
      width="400px"
      custom-class="export-modal"
      @close="showOriginalExportModal=false"
      :lock-scroll="false"
    >
      <div class="export-options">
        <label>格式</label>
        <template>
          <el-radio v-model="exportFileType" label="1">.doc</el-radio>
          <el-radio v-model="exportFileType" label="2">.pdf</el-radio>
        </template>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showOriginalExportModal = false">取 消</el-button>
        <el-button type="primary" @click="exportOriginalResumeFile">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
//接口：1.获取已购项目详情   2.获取用户基本信息及文件信息   3.原始简历上传  4.导出优化的简历  5.交付简历  6.职业生涯报告导出  7.交付职业生涯规划 8.检查简历是否可以交付
import {
  httpBoughtItemInfoGet,
  httpBuyerInfoGet,
  httpResumeUploadOriginal,
  httpResumeExport,
  httpResumeDelivery,
  httpCareerPlanExport,
  httpCareerPlanDelivery,
  httpResumeDeliveryCheck,
  httpInterviewExport,
  httpInterviewDelivery,
  httpInterviewDeliveryCheck
} from "@/api/orderDetails";

import FatalError from "@/components/Common/FatalError.vue";
import PlanEditor from "@/components/Common/PlanEditor.vue";
import InterviewEditor from "@/components/Editor/InterviewEditor.vue";

import ResumeBaseInfo from "@/components/EditResume/ResumeBaseInfo.vue";
import ResumeJobIntension from "@/components/EditResume/ResumeJobIntension.vue";
import ResumeWorkExperience from "@/components/EditResume/ResumeWorkExperience.vue";
import ResumeProjectExperience from "@/components/EditResume/ResumeProjectExperience.vue";
import ResumeEducationalBackground from "@/components/EditResume/ResumeEducationalBackground.vue";
import ResumeSelfIntroduction from "@/components/EditResume/ResumeSelfIntroduction.vue";
import ResumeLanguageAbility from "@/components/EditResume/ResumeLanguageAbility.vue";
import config from "@/config";

export default {
  name: "OrderDetails",
  props: {
    id: {
      type: String,
      required: true
    }
  },
  components: {
    InterviewEditor,
    PlanEditor,
    FatalError,
    ResumeBaseInfo,
    ResumeJobIntension,
    ResumeWorkExperience,
    ResumeProjectExperience,
    ResumeEducationalBackground,
    ResumeSelfIntroduction,
    ResumeLanguageAbility
  },
  data() {
    return {
      itemList: [],
      activeTypeId: "", //当前被激活的项目类型id，1-简历优化，2-职业规划
      orderId: '',
      resumeOrderDetailId: "",
      planOrderDetailId: "",
      resumeId: 0,
      planId: 0,
      interviewId: 0,
      interviewOrderDetailId: "",
      deliverTime: "",
      showFatalError: false,
      fatalErrorText: "",
      exportFileType: "1",
      showDeliveryModal: false, //交付弹窗
      showExportModal: false,
      userInfo: {},
      didResumeIdGet: false, //判断简历Id是否已经拿到
      isEditable: true, //false代表不可编辑，true代表还可继续编辑简历详情或者职业规划
      changeable: true,
      showOriginalExportModal: false, //下载原始简历窗口
      userResumeId: null //用户简历下载编号
    };
  },
  created() {
    this.orderId=this.$route.query.id || this.$route.params.id;
    console.log(this.$route.params.id,this.$route.query.id,"-----this.orderId",this.orderId)
    this.getBoughtItemInfo();
  },
  mounted() {
    this.setMenuActive();
  },
  destroyed() {
    this.cancelMenuActive();
  },
  methods: {
    //下载原始简历
    downloadOriginalResuem() {
      if (!this.userResumeId) {
        return this.$message.error("用户并没有上传或添加简历！");
      }
      this.showOriginalExportModal = true;
    },
    //执行导出操作
    exportOriginalResumeFile() {
      if (this.userResumeId) {
        let downloadUrl =
          config.DownloadUrlBase +
          "api/user/downloadresumefile?ResumeId=" +
          this.userResumeId +
          "&Type=" +
          this.exportFileType;
        this.showOriginalExportModal = false;
        setTimeout(() => {
          this.fileDownload(downloadUrl);
        }, 150);
      } else {
        this.$message.error("用户并没有上传或添加简历！");
      }
    },
    setMenuActive() {
      var oTab = document.querySelectorAll(".tab-title")[0];
      oTab.classList.add("router-link-active");
    },

    cancelMenuActive() {
      var oTab = document.querySelectorAll(".tab-title")[0];
      oTab.classList.remove("router-link-active");
    },

    //此方法需要优化，不可改变props
    changeEditAble(status) {
      if (status == 1) {
        this.isEditable = false;
      } else {
        this.isEditable = true;
      }
    },

    //此方法需要修改
    changeResumeId(result) {
      //console.log(result);
      this.resumeId = result;
    },

    //点击导出的时候判断是否可以导出
    checkExport() {
      let orderId = this.orderId;
      //简历导出
      if (this.activeTypeId == 1) {
        httpResumeExport(orderId).then(r => {
          //console.log(r);
          if (r.success) {
            this.callOutExportModal();
          } else {
            this.$message.error(r.message);
          }
        });
      }

      //规划导出
      if (this.activeTypeId == 2) {
        httpCareerPlanExport(orderId).then(r => {
          if (r.success) {
            this.callOutExportModal();
          } else {
            this.$message.error("请先完善职业规划");
          }
        });
      }

      //面试辅导导出
      if (this.activeTypeId == 3) {
        httpInterviewDeliveryCheck(this.orderId).then(r => {
          if (r.success) {
            this.callOutExportModal();
          } else {
            this.$message.error("请先完善面试辅导");
          }
        });
      }
    },

    //呼出导出弹窗
    callOutExportModal() {
      this.showExportModal = true;
    },

    //执行导出操作
    exportFile() {
      let orderId = this.orderId;
      //简历导出
      if (this.activeTypeId == 1) {
        httpResumeExport(orderId)
          .then(r => {
            //console.log(r);
            if (r.success) {
              let downloadUrl =
                "http://jianyouexp.risfond.com/api/OrderResume/downloadresumefile?ResumeId=" +
                this.resumeId +
                "&Type=" +
                this.exportFileType;
              this.showExportModal = false;
              setTimeout(() => {
                this.fileDownload(downloadUrl);
              }, 150);
            } else {
              this.$message.error(r.message);
            }
          })
          .catch(err => {
            console.log(err);
            this.$message.error("简历导出失败");
          });
      }

      //规划导出
      if (this.activeTypeId == 2) {
        httpCareerPlanExport(orderId)
          .then(r => {
            //console.log(r);
            if (r.success) {
              let downloadUrl =
                "http://jianyouexp.risfond.com/api/OrderCareePlan/downloadcareerplan?CareePlanId=" +
                this.planId +
                "&Type=" +
                this.exportFileType;
              this.showExportModal = false;
              setTimeout(() => {
                this.fileDownload(downloadUrl);
              }, 50);
            } else {
              this.$message.error(r.message);
            }
          })
          .catch(err => {
            console.log(err);
            this.$message.error("职业生涯规划导出失败");
          });
      }

      //面试辅导导出
      if (this.activeTypeId == 3) {
        httpInterviewDeliveryCheck(this.orderId)
          .then(r => {
            if (r.success) {
              let downloadUrl =
                "http://jianyouexp.risfond.com/api/InterviewCoach/dowloadinterviewcoach?CoachId=" +
                this.interviewId +
                "&Type=" +
                this.exportFileType;
              this.showExportModal = false;
              setTimeout(() => {
                this.fileDownload(downloadUrl);
              }, 50);
            } else {
              this.$message.error(r.message);
            }
          })
          .catch(err => {
            console.log(err);
            this.$message.error("面试辅导出失败");
          });
      }
    },

    // 创建隐藏的可下载链接
    fileDownload(downloadUrl, filename) {
      let eleLink = document.createElement("a");
      eleLink.style.display = "none";
      eleLink.href = downloadUrl;
      // 触发点击-然后移除
      document.body.appendChild(eleLink);
      eleLink.click();
      document.body.removeChild(eleLink);
    },

    //---------------->>>>>>>>>检查是否可以交付
    checkDelivery() {
      if (!this.isEditable) return;

      let orderId = this.orderId;
      //简历优化的话判断是否上传原始简历
      if (this.activeTypeId == 1) {
        // if (!this.userInfo.resumeUrl) {
        //   this.$message({
        //     type: "info",
        //     message: "请您先上传原始简历",
        //     duration: 1300
        //   });
        //   return;
        // }

        //如果没有填写基本信息的话，那么不允许交付
        httpResumeDeliveryCheck(this.orderId).then(r => {
          if (!r.success) {
            this.$message({
              type: "info",
              message: "请您先完善简历的基本信息",
              duration: 1300
            });
          } else {
            this.showDeliveryModal = true;
          }
        });
      }

      //判断规划是否可以交付
      if (this.activeTypeId == 2) {
        httpCareerPlanExport(orderId).then(r => {
          if (r.success) {
            this.showDeliveryModal = true;
          } else {
            this.$message({
              type: "info",
              message: "请您先完善职业生涯规划",
              duration: 1300
            });
          }
        });
      }

      //面试辅导导出
      if (this.activeTypeId == 3) {
        httpInterviewDeliveryCheck(this.orderId).then(r => {
          if (r.success) {
            this.showDeliveryModal = true;
          } else {
            this.$message({
              type: "info",
              message: "请您先完善面试辅导",
              duration: 1300
            });
          }
        });
      }
    },

    //交付简历
    deliveryResume(typeId) {
      let oData = {
        orderId: this.orderId,
        resumeId: this.resumeId,
        status: 1
      };
      httpResumeDelivery(oData)
        .then(r => {
          //console.log(r);
          if (r.success) {
            this.$message({
              type: "success",
              message: "简历交付成功",
              duration: 1200,
              onClose: () => {
                this.itemList.forEach(item => {
                  if (item.serviceItemId == typeId) {
                    item.deliverTime = r.data;
                  }
                });
                this.showDeliveryModal = false;
              }
            });
          } else {
            this.$message({
              type: "error",
              message: "简历交付失败," + r.message,
              onClose: () => {
                this.showDeliveryModal = false;
              }
            });
          }
        })
        .catch(err => {
          //console.log(err);
          this.$message({
            type: "error",
            message: "简历交付失败,",
            onClose: () => {
              this.showDeliveryModal = false;
            }
          });
        });
    },

    //交付职业生涯规划
    deliveryCareerPlan(typeId) {
      let oData = {
        orderId: this.orderId,
        planId: this.planId || 1,
        status: 1
      };

      httpCareerPlanDelivery(oData)
        .then(r => {
          //console.log(r);
          if (r.success) {
            this.$message({
              type: "success",
              message: "职业生涯规划交付成功",
              duration: 1200,
              onClose: () => {
                this.itemList.forEach(item => {
                  if (item.serviceItemId == typeId) {
                    item.deliverTime = r.data;
                  }
                });
                this.showDeliveryModal = false;
              }
            });
          } else {
            this.$message({
              type: "error",
              message: "职业生涯规划交付失败," + r.message,
              onClose: () => {
                this.showDeliveryModal = false;
              }
            });
          }
        })
        .catch(err => {
          console.log(err);
          this.$message({
            type: "error",
            message: "职业生涯规划交付失败",
            onClose: () => {
              this.showDeliveryModal = false;
            }
          });
        });
    },

    //交付面试辅导
    deliveryInterview(typeId) {
      let oData = {
        orderId: this.orderId,
        coachId: this.interviewId
      };

      httpInterviewDelivery(oData)
        .then(r => {
          //console.log(r);
          if (r.success) {
            this.$message({
              type: "success",
              message: "面试辅导划交付成功",
              duration: 1200,
              onClose: () => {
                this.itemList.forEach(item => {
                  if (item.serviceItemId == typeId) {
                    item.deliverTime = r.data;
                  }
                });
                this.showDeliveryModal = false;
              }
            });
          } else {
            this.$message({
              type: "error",
              message: "面试辅导交付失败," + r.message,
              onClose: () => {
                this.showDeliveryModal = false;
              }
            });
          }
        })
        .catch(err => {
          console.log(err);
          this.$message({
            type: "error",
            message: "面试辅导交付失败",
            onClose: () => {
              this.showDeliveryModal = false;
            }
          });
        });
    },

    //上传简历
    uploadResuem(event) {
      if (typeof FileReader === "undefined") {
        alert("抱歉，你的浏览器版本过于老旧，请使用新版浏览器操作！");
        return;
      }
      // 获取当前选中的文件
      var e = window.event || event;
      var oFile = e.target.files[0];
      // 限制文件类型
      var fileType = oFile.name.substr(oFile.name.lastIndexOf(".") + 1);
      if (
        ["doc", "docx", "pdf", "png", "jpg", "jpeg", "xls", "xlsx"].indexOf(
          fileType
        ) < 0
      ) {
        this.$message.error(
          "只支持.doc .docx .xls .xlsx .pdf .png .jpg .jpeg 格式文件"
        );
        return;
      }
      var imgMaxSize = 1024 * 1024 * 10; // 10MB图片的字节数
      if (oFile.size > imgMaxSize) {
        this.$message.error("您可上传文件的最大限制为10MB");
        return;
      }
      var fileStringBase64;
      var fileStringBase64Type;

      let vm = this;
      var reader = new FileReader();
      reader.readAsDataURL(oFile, "UTF-8");

      reader.onload = function() {
        fileStringBase64 = this.result;
        fileStringBase64 = fileStringBase64.substring(
          fileStringBase64.indexOf(",") + 1,
          fileStringBase64.length
        ); //正文部分
        let fileType = oFile.name.substr(oFile.name.lastIndexOf(".") + 1);
        let oData = {
          orderId: vm.orderId,
          fileBase64String: fileStringBase64,
          fileName: oFile.name,
          FileSize: oFile.size
        };
        vm.doUpload(oData);
      };
    },

    //上传-数据交互
    doUpload(data) {
      httpResumeUploadOriginal(data)
        .then(r => {
          //console.log(r);
          if (r.success) {
            this.$notify({
              type: "success",
              title: "成功",
              message: "原始简历上传成功"
            });
            this.getBuyerInfo();
          } else {
            this.$notify({
              type: "error",
              title: "失败",
              message: "上传文件失败，请稍后再试"
            });
          }
        })
        .catch(err => {
          this.$notify({
            type: "error",
            title: "失败",
            message: "上传文件失败，请稍后再试"
          });
        });
    },

    //切换选项卡
    switchTab(index, operable, itemTypeId) {
      //如果是选中状态，不执行任何操作
      if (operable) return;
      this.itemList.forEach(item => {
        item.active = false;
      });

      this.itemList[index].active = true;
      this.activeTypeId = itemTypeId;
      //this.getBoughtItemInfo();
    },

    //获取购买项目
    getBoughtItemInfo() {
      this.$loader({
        showLoader: true,
        iconType: 3,
        tips: "查询详情中...",
        duration: 500
      });
      let id = this.orderId;

      httpBoughtItemInfoGet(id)
        .then(r => {
          //console.log(r);
          if (r.success) {
            this.itemList = r.data;
            const len = this.itemList.length;
            this.userResumeId = this.itemList[0].userResumeId;
            this.itemList.forEach(item => {
              //如果是简历优化的话
              if (item.serviceItemId == 1) {
                this.resumeId = item.resumeId || 0;
                this.resumeOrderDetailId = item.detailId;
                if (!this.didResumeIdGet) {
                  setTimeout(() => {
                    this.didResumeIdGet = true;
                  }, 30);
                }
              }
              if (item.serviceItemId == 2) {
                this.planId = item.careerPlanId || 0;
                this.planOrderDetailId = item.detailId;
              }

              //interviewId
              if (item.serviceItemId == 3) {
                this.interviewId = item.interviewCoachId || 0;
                this.interviewOrderDetailId = item.detailId;
              }
              this.$set(item, "active", false);
            });

            this.itemList[0].active = true;
            this.deliverTime = this.itemList[0].deliverTime || "";
            this.isEditable = this.itemList[0].isEdit; //是否可以编辑
            this.changeable = this.itemList[0].isEdit;
            this.activeTypeId = this.itemList[0].serviceItemId;

            this.getBuyerInfo(); //获取用户基本信息
          } else {
            this.$message.error("获取用户购买项目清单出错");
          }
        })
        .catch(err => {
          console.log(err);
          this.showFatalError = true;
          this.$message.error("获取用户购买项目清单出错");
        });
    },

    //获取购买者基本信息
    getBuyerInfo() {
      const id = this.orderId;
      httpBuyerInfoGet(id)
        .then(r => {
          //console.log(r);
          if (r.success) {
            this.userInfo = r.data;
          } else {
            this.$notify({
              type: "error",
              title: "失败",
              message: "获取用户信息失败"
            });
          }
        })
        .catch(err => {
          console.log(err);
          this.$notify({
            type: "error",
            title: "警告",
            message: "获取用户信息失败"
          });
        });
    }
  } //methods结束标记
};
</script>

<style scoped lang='less'>
.order-details {
  position: relative;
  padding: 20px 20px 60px 38px;
  min-height: 900px;
  .tabs-container {
    width: 770px;
  }
}

.tabs {
  position: relative;
  width: 770px;
  margin-bottom: 30px;
  .tabs-ul {
    position: relative;
    border-bottom: 1px solid #eee;
  }
  .tab-links {
    line-height: 80px;
    float: left;
    color: #666;
    font-size: 16px;
    margin-right: 30px;
    &.active {
      color: #333333;
      font-weight: bold;
      box-shadow: 0 -2px 0 #3b87ff inset;
    }
  }
}

.resume-op-box {
  position: relative;
  margin: 20px 0;
  min-height: 20px;
  .deliver-time {
    color: #999;
    font-size: 12px;
    .important {
      margin-left: 15px;
    }
  }
}

.op-box {
  position: absolute;
  right: 0;
  top: 0;
}

.op-btn {
  display: block;
  float: right;
  width: 70px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  border-radius: 2px;
  margin-left: 8px;
  &.export-btn {
    background-color: #eee;
    color: #333;
  }
  &.deliver-btn {
    background-color: #3b87ff;
    color: #fff;
  }
  &.disabled {
    cursor: not-allowed;
  }
}

.user-box {
  position: absolute;
  top: 34px;
  right: 0;
  width: 212px;
  .user-info-box {
    text-align: center;
    overflow: hidden;
    background-color: #f5f5f5;
    margin-bottom: 15px;
    border: 1px solid #eee;
    height: 192px;
    .avata {
      display: block;
      margin: 25px auto 14px;
      width: 70px;
      height: 70px;
      border-radius: 50%;
    }
    h3 {
      margin-bottom: 11px;
      color: #333;
      height: 20px;
      font-size: 14px;
    }
  }
}

.icon {
  position: relative;
  width: 20px;
  height: 20px;
  float: left;
  display: inline-block;
  margin-right: 8px;
  &.icon-phone {
    width: 13px;
  }
  img {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 16px;
    vertical-align: middle;
  }
}

.info-contact {
  width: 118px;
  margin: 0 auto 30px;
  span {
    font-size: 14px;
    float: left;
  }
}

.user-resume-box {
  box-sizing: border-box;
  width: 100%;
  height: 134px;
  background-color: #f5f5f5;
  padding: 24px 14px;
  border: 1px solid #eee;
}

.upload-box {
  position: relative;
  .real-upload-btn {
    position: relative;
    display: block;
    width: 130px;
    margin: 0 auto 15px auto;
    line-height: 30px;
    cursor: pointer;
    opacity: 0;
    z-index: 2;
  }
  .fake-upload-btn {
    display: block;
    width: 130px;
    line-height: 30px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    background-color: #3b87ff;
    color: #fff;
    text-align: center;
    border-radius: 2px;
    i {
      font-size: 18px;
      font-weight: lighter;
      line-height: 18px;
      margin-right: 3px;
    }
  }
  .upload-tips {
    color: #666;
    font-size: 12px;
    text-align: center;
  }
}

.user-file-box {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 124px;
  background-color: #f5f5f5;
  padding: 18px 14px 16px 14px;
  border: 1px solid #eee;
  &::after {
    content: "";
    position: absolute;
    top: 82px;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: #eee;
  }
  h3 {
    width: 182px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    color: #333;
  }
  .time {
    font-size: 12px;
    color: #999;
    margin: 14px 0 24px;
    span {
      margin-left: 8px;
    }
  }
}

.file-btn-box {
  display: flex;
  align-content: center;
  justify-content: flex-end;
  .btn-file {
    color: #3b87ff;
    font-size: 14px;
  }
}

.upload-box-small {
  position: relative;
  .samll-upload-btn {
    position: relative;
    width: 60px;
    opacity: 0;
    margin-left: 20px;
    cursor: pointer;
    z-index: 2;
  }
  .btn-reupload {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto 0;
    z-index: 1;
    cursor: pointer;
  }
}

.export-modal {
  font-size: 14px;
}

.export-options {
  label {
    margin-right: 23px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/MyOrder/OrderDetails.vue